import { render, staticRenderFns } from "./editCategoryModal.vue?vue&type=template&id=6f395e78"
import script from "./editCategoryModal.vue?vue&type=script&lang=js"
export * from "./editCategoryModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports